import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const ForkKnife = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M11.333 4a.666.666 0 00-.666.667V8H9.333V4.667a.666.666 0 10-1.333 0V8H6.667V4.667a.666.666 0 10-1.334 0V10c0 1.103.898 2 2 2v6.667a1.333 1.333 0 002.667 0V12c1.103 0 2-.897 2-2V4.667A.666.666 0 0011.333 4zm2 5.333v5.334H16v4a1.333 1.333 0 002.667 0V4a5.334 5.334 0 00-5.334 5.333z"
        id="prefix__a--fork-knife"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b--fork-knife" fill="#fff">
        <use xlinkHref="#prefix__a--fork-knife" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#prefix__a--fork-knife" />
      <g
        mask="url(#prefix__b--fork-knife)"
        fill={props.color || theme.palette.grey800}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
